module.exports = __webpack_public_path__ + "static/media/pulseira.605511ad.png";